import { useQuery } from '@tanstack/react-query'

import { ClientBookingSearchService } from '../services/client_booking_search.service'
import { APIBookingSearchByDaysClientDtoResponse, APIBookingSearchClientDtoResponse } from '../types/api'
import { TBookingSearchOptions } from '../types/general'
import { DEFAULT_CACHE_TIME, defaultQueryOptions } from './common'

export const useClientBookingSearch = (
  locationName: string,
  serviceTypeName: string,
  options: TBookingSearchOptions
) => {
  const { cacheEnabled = false, enabled = true, ...queryOptions } = options

  return useQuery<APIBookingSearchClientDtoResponse>({
    queryKey: ['clientBookingSearchRegular', locationName, serviceTypeName, queryOptions],
    queryFn: () => ClientBookingSearchService.search(locationName, serviceTypeName, queryOptions),
    // disable the call if the date is invalid
    enabled: enabled && options.startDate !== '1969-12-31',
    ...defaultQueryOptions,
    ...(cacheEnabled ? { staleTime: DEFAULT_CACHE_TIME, cacheTime: DEFAULT_CACHE_TIME } : {}),
  })
}

export const useClientBookingSearchByDays = (
  locationName: string,
  serviceTypeName: string,
  options: TBookingSearchOptions
) => {
  const { enabled = true, ...searchOptions } = options

  return useQuery<APIBookingSearchByDaysClientDtoResponse>({
    queryKey: ['clientBookingSearchByDays', locationName, serviceTypeName, searchOptions],
    queryFn: () => ClientBookingSearchService.searchByDays(locationName, serviceTypeName, searchOptions),
    // disable the call if the date is invalid
    enabled: enabled && options.startDate !== '1969-12-31',
    ...defaultQueryOptions,
  })
}
